import React, { useState } from 'react';
import { Building } from './types';
import { HotelFloor } from './HotelFloor';
import { ArrowUpDown } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  building: Building;
};

export const BuildingView = ({ building }: Props) => {
  const [activeFloor, setActiveFloor] = useState(
    building.floors[0]?.number || 1
  );
  const { translations } = useLanguage();

  return (
    <div className="space-y-6 p-4">
      {/* Floor Navigation */}
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-primary-50 rounded-lg">
            <ArrowUpDown className="text-primary-500" size={20} />
          </div>
          <div>
            <h3 className="font-medium">
              {translations?.buildingView?.floorNavigationTitle || 'Floors'}
            </h3>
            <p className="text-sm text-gray-500">
              {translations?.buildingView?.floorNavigationSubtitle ||
                'Select a floor to view its details'}
            </p>
          </div>
        </div>

        <div className="flex gap-2 overflow-x-auto pb-2">
          {building.floors.map((floor) => (
            <button
              key={floor.number}
              onClick={() => setActiveFloor(floor.number)}
              className={`
                px-4 py-2 rounded-lg transition-all min-w-[60px] text-sm sm:text-base
                ${
                  activeFloor === floor.number
                    ? 'bg-primary-500 text-white'
                    : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                }
              `}
            >
              {floor.number}
            </button>
          ))}
        </div>
      </div>

      {/* Floor View */}
      {building.floors.map((floor) => (
        <HotelFloor
          key={floor.number}
          floorNumber={floor.number}
          rooms={floor.rooms}
          isActive={activeFloor === floor.number}
        />
      ))}
    </div>
  );
};